module.exports = __webpack_public_path__ + "static/media/warning-circle.fc023029.svg";